import React from 'react';
import { Icon } from './Icon.js';
export const IconCube = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 22.5V11", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M22 6.57895L12 11L2 6.57895", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M22 18.0789V5.92105L12 1.5L2 5.92105V18.0789L12 22.5L22 18.0789Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", fill: "none" })));
};
//# sourceMappingURL=IconCube.js.map